<template>
  <div class="dialog-wrap">
    <el-dialog
      title="科目编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入科目名称"></el-input>
        </el-form-item>
        <el-form-item label="科目代码" prop="code">
          <el-input v-model="dataForm.code" placeholder="请输入科目代码，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="科目分类" prop="category_id">
          <el-select v-model="dataForm.category_id" placeholder="请选择科目分类" style="width: 100%;">
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统考" prop="type">
          <el-select v-model="dataForm.type" placeholder="请选择统考状态" style="width: 100%;">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { subjectUpdate, subjectCategoryList } from '@/api/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {
        type:  1
      },
      types: [
        {label: '统考', value: 1},
        {label: '非统考', value: 0}
      ],
      categorys: [],
      rules: {
        name: [{ required: true, message: '请输入科目名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入科目代码，纯数字', trigger: 'blur' }],
        type: [{ required: true, message: '请选择统考状态', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCategoryList()
      }
    },
    content (val) {
      this.dataForm = val
    }
  },
  methods: {
    fetchCategoryList() {
      subjectCategoryList({isPaging: 0}).then(res => {
        this.categorys = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            code: this.dataForm.code,
            category_id: this.dataForm.category_id,
            type:  this.dataForm.type,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0
          }
          subjectUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
  }
</style>
